// Der Abfragebaum der Suche (ST-SEA-002, „PQL Grundlage“; CM-SEA-004,
// CM-SEA-015).
//
// Fachsyntax, Filterbereich und spaeter der Builder erzeugen denselben Baum.
// Die Schluessel sind englisch wie im uebrigen API-Vertrag, weil der Baum mit
// S4 als Rumpf an den Server geht. Die Zeichenbereiche (`span`) gehoeren nur
// dem Web: mit ihnen setzt der Bildschirm den Cursor an die Stelle eines
// Hinweises. Sie reisen nie zum Server.

/** Fassung der Feldliste, die diesen Baum erzeugt hat (ST-SEA-002, S3 loest sie ab). */
export const REGISTRY_VERSION = 'web-1';

/** Zeichenbereich im Suchtext, `from` einschliesslich, `to` ausschliesslich. */
export interface Span {
  readonly from: number;
  readonly to: number;
}

export type FieldOperator = 'equals' | 'gt' | 'gte' | 'lt' | 'lte';

/** Ein Wert einer Angabe; `quoted` merkt sich nur die Schreibweise fuer den Printer. */
export interface QueryValue {
  readonly value: string;
  readonly quoted: boolean;
  readonly span: Span;
}

export interface FieldNode {
  readonly field: string;
  /** So wie getippt, fuer Zitate in Hinweisen. */
  readonly fieldSpelling: string;
  readonly op: FieldOperator;
  readonly values: readonly QueryValue[];
  readonly span: Span;
}

/** Freitext: zusammenhaengende Woerter sind EIN Teilstring wie der heutige `term` (E4 c). */
export interface TextNode {
  readonly text: string;
  readonly quoted: boolean;
  readonly span: Span;
}

export interface AndNode {
  readonly and: readonly QueryNode[];
  readonly span: Span;
}

export interface OrNode {
  readonly or: readonly QueryNode[];
  readonly span: Span;
}

export interface NotNode {
  readonly not: QueryNode;
  readonly span: Span;
}

export type QueryNode = AndNode | OrNode | NotNode | FieldNode | TextNode;

export function isAnd(node: QueryNode): node is AndNode {
  return 'and' in node;
}

export function isOr(node: QueryNode): node is OrNode {
  return 'or' in node;
}

export function isNot(node: QueryNode): node is NotNode {
  return 'not' in node;
}

export function isField(node: QueryNode): node is FieldNode {
  return 'field' in node;
}

export function isText(node: QueryNode): node is TextNode {
  return 'text' in node;
}
